export default __webpack_public_path__ + "static/OPTIMA-dc3d2a054ce089b37bb721f629f68916.ttf";